import {
  HOME_ROUTE,
  SELECT_PRODUCT_MOBILE,
  MOTIVE_MESSAGE_MOBILE,
  TICKET_SUCCESSFUL,
  TICKET_SUCCESSFUL_INNER_FORMS,
  TICKET_ERROR,
  NOT_RECEIVED_PRODUCT,
  NOT_RECEIVED_PRODUCT_MOBILE,
  AUTHORIZE_THIRD,
  AUTHORIZE_THIRD_MOBILE,
  CHANGE_ADDRESS,
  CHANGE_ADDRESS_MOBILE,
  CHANGE_DATE,
  CHANGE_DATE_MOBILE,
  GOLD_DISPATCH_CHARGE,
  GOLD_DISPATCH_CHARGE_MOBILE,
  BAD_STATE_PRODUCT,
  INCOMPLETE_PRODUCT,
  OTHER_PRODUCT,
  NOT_WORKING_PRODUCT,
  CHANGE_PRODUCT,
  CHANGE_PRODUCT_MOBILE,
  PRODUCT_WITH_ALARM,
  CANCEL_PURCHASE,
  STATUS_CANCEL_PURCHASE,
  REVERSE_OUT_OF_TIME,
  ASSEMBLE_PRODUCT,
  CHANGE_PASS_RIPLEY_COM,
  CHANGE_PASS_RIPLEY_COM_MOBILE,
  CHANGE_EMAIL,
  CHANGE_EMAIL_MOBILE,
  INVOICE_COPY,
  PROBLEM_IN_PURCHASE,
  PAGE_ERROR,
  REMOVE_CLIENT_DATA,
  GET_GIFTCARD_BALANCE,
  EXTEND_VALIDITY,
  PROBLEMS_GIFTCARD,
  PROBLEMS_GIFTCARD_MOBILE,
  ARCO_LAW_INFO,
  RPHONE,
  DEBIT,
  PROVIDERS,
  STORE,
} from '../constants/routes';

const homeBasePath = {
  prevRoute: HOME_ROUTE,
  titlePrevRoute: 'menú de contacto',
};

export const routerTreeMap = new Map();
routerTreeMap.set(SELECT_PRODUCT_MOBILE, homeBasePath);
routerTreeMap.set(MOTIVE_MESSAGE_MOBILE, homeBasePath);

routerTreeMap.set(TICKET_SUCCESSFUL, homeBasePath);
routerTreeMap.set(TICKET_SUCCESSFUL_INNER_FORMS, homeBasePath);
routerTreeMap.set(TICKET_ERROR, homeBasePath);

routerTreeMap.set(NOT_RECEIVED_PRODUCT, homeBasePath);
routerTreeMap.set(NOT_RECEIVED_PRODUCT_MOBILE, homeBasePath);
routerTreeMap.set(AUTHORIZE_THIRD, homeBasePath);
routerTreeMap.set(AUTHORIZE_THIRD_MOBILE, homeBasePath);
routerTreeMap.set(CHANGE_ADDRESS, homeBasePath);
routerTreeMap.set(CHANGE_ADDRESS_MOBILE, homeBasePath);
routerTreeMap.set(CHANGE_DATE, homeBasePath);
routerTreeMap.set(CHANGE_DATE_MOBILE, homeBasePath);
routerTreeMap.set(GOLD_DISPATCH_CHARGE, homeBasePath);
routerTreeMap.set(GOLD_DISPATCH_CHARGE_MOBILE, homeBasePath);

routerTreeMap.set(BAD_STATE_PRODUCT, homeBasePath);
routerTreeMap.set(INCOMPLETE_PRODUCT, homeBasePath);
routerTreeMap.set(OTHER_PRODUCT, homeBasePath);
routerTreeMap.set(NOT_WORKING_PRODUCT, homeBasePath);
routerTreeMap.set(CHANGE_PRODUCT, homeBasePath);
routerTreeMap.set(CHANGE_PRODUCT_MOBILE, homeBasePath);
routerTreeMap.set(PRODUCT_WITH_ALARM, homeBasePath);

routerTreeMap.set(CANCEL_PURCHASE, homeBasePath);
routerTreeMap.set(STATUS_CANCEL_PURCHASE, homeBasePath);
routerTreeMap.set(REVERSE_OUT_OF_TIME, homeBasePath);

routerTreeMap.set(ASSEMBLE_PRODUCT, homeBasePath);

routerTreeMap.set(CHANGE_PASS_RIPLEY_COM, homeBasePath);
routerTreeMap.set(CHANGE_PASS_RIPLEY_COM_MOBILE, homeBasePath);
routerTreeMap.set(CHANGE_EMAIL, homeBasePath);
routerTreeMap.set(CHANGE_EMAIL_MOBILE, homeBasePath);
routerTreeMap.set(INVOICE_COPY, homeBasePath);
routerTreeMap.set(PROBLEM_IN_PURCHASE, homeBasePath);
routerTreeMap.set(PAGE_ERROR, homeBasePath);
routerTreeMap.set(REMOVE_CLIENT_DATA, homeBasePath);

routerTreeMap.set(GET_GIFTCARD_BALANCE, homeBasePath);
routerTreeMap.set(EXTEND_VALIDITY, homeBasePath);
routerTreeMap.set(PROBLEMS_GIFTCARD, homeBasePath);
routerTreeMap.set(PROBLEMS_GIFTCARD_MOBILE, homeBasePath);

routerTreeMap.set(ARCO_LAW_INFO, homeBasePath);

routerTreeMap.set(RPHONE, homeBasePath);
routerTreeMap.set(DEBIT, homeBasePath);
routerTreeMap.set(PROVIDERS, homeBasePath);
routerTreeMap.set(STORE, homeBasePath);
